import { render, staticRenderFns } from "./CustomerAirport.vue?vue&type=template&id=3c6b5361&"
import script from "./CustomerAirport.vue?vue&type=script&lang=js&"
export * from "./CustomerAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports